import { render, staticRenderFns } from "./CloudcanteenPublicSummary.vue?vue&type=template&id=a3fdce1c&"
import script from "./CloudcanteenPublicSummary.vue?vue&type=script&lang=js&"
export * from "./CloudcanteenPublicSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports